// extracted by mini-css-extract-plugin
export default {"container":"ProjectSummary__container___Hticb","title":"ProjectSummary__title___QsLle","lastRow":"ProjectSummary__lastRow___b21YZ"};